import React from 'react';
import clsx from 'clsx';
import { ReactComponent as Unchecked } from '../../../assets/common/unchecked.svg';
import { ReactComponent as Checked } from '../../../assets/common/checked.svg';
import './TaskCheckBox.scss';

interface TaskCheckBoxProps {
  isCompleted: boolean;
  onChange: (checked: boolean) => void;
  className?: string;
  size?: number;
  color?: string;
  disabled?: boolean;
  hasPriority?: boolean;
  svgRatio?: number;
}

export const TaskCheckBox: React.FC<TaskCheckBoxProps> = ({
  isCompleted,
  onChange,
  className = '',
  size = 20,
  color = 'var(--color-primary)',
  disabled = false,
  hasPriority = false,
  svgRatio = 0.8,
}) => {
  const style = {
    '--checkbox-width': `${size}px`,
    '--checkbox-height': `${size}px`,
    '--checkbox-color': color,
    '--checkbox-icon-size': `${size * 0.8}px`, // Icon is 70% of checkbox size
  } as React.CSSProperties;

  return (
    <div
      className={clsx(
        'task-checkbox',
        isCompleted && 'task-checkbox--completed',
        disabled && 'task-checkbox--disabled',
        hasPriority && 'task-checkbox--priority',
        className
      )}
      onClick={(e) => {
        e.stopPropagation();
        if (disabled) return;
        onChange(!isCompleted);
      }}
      role="checkbox"
      aria-checked={isCompleted}
      aria-disabled={disabled}
      style={style}
    >
      <div className="task-checkbox__inner">
        {isCompleted ? (
          <Checked style={{ width: `${size * svgRatio}px`, height: `${size * svgRatio}px` }} />
        ) : (
          <Unchecked style={{ width: `${size * svgRatio}px`, height: `${size * svgRatio}px` }} />
        )}
      </div>
    </div>
  );
};
